
// export const Base_Url = "http://62.72.30.137:8187"

// export const Base_Url = "http://jaidurgamobilegallery.com:8187"
export const Base_Url = "http://jaidurgamobilegallery.franticpro.com:8187"





